import jQuery from 'jquery';
let afg_helpers = {};

afg_helpers.exists = (el) => {
  if(el === undefined || el === null) return false;
  if(el.length === 0) return false;
  return true;
}

afg_helpers.scrollDirection = () => {

  document.addEventListener("DOMContentLoaded", function(event) {

    let lastScrollTop = 0;
    let offset = document.body.classList.contains('single') ? 0 : 100;
    let scrollTop = window.scrollY;
    let menuOpen = false;

    window.addEventListener('scroll', function(e) {
      
      scrollTop = window.scrollY;

      let mobileNav = document.querySelectorAll('.et-l--header .mobile_nav');
      if(mobileNav[0] !== undefined || mobileNav[0] !== null) {
        if(mobileNav[0].classList.contains('opened')) {
          menuOpen = true;
        } else {
          menuOpen = false;
        }
      }

      if (scrollTop > lastScrollTop && menuOpen === false ) {
        document.body.classList.add('scroll-down');
        document.body.classList.remove('scroll-up');
        
      } else {
        document.body.classList.add('scroll-up');
        document.body.classList.remove('scroll-down');
        
      }

      if(scrollTop <= offset) {
        document.body.classList.add('scroll-offset');
      } else {
        document.body.classList.remove('scroll-offset');
      }

      lastScrollTop = scrollTop;

    });

    window.onload = function() {
      if(scrollTop > offset) {
          document.body.classList.add('scroll-up');
          document.body.classList.remove('scroll-down');
      }
    }

  });


}

afg_helpers.clickAll = (selector) => {

    let clickEls = document.querySelectorAll(selector);

    let transition = document.querySelector('.load-transition');
    
    if(clickEls === undefined) return;
      
    clickEls.forEach(clickEl => {

      clickEl.addEventListener('click',function(e){
        
        e.preventDefault();
        e.stopPropagation();
        
        let link = clickEl.querySelectorAll('h2 a');
        let href = false;
        if(link.length !== undefined) href = link[0].getAttribute('href');


        if(href !== undefined) {
          transition.classList.add('afg-active');
          window.location = href;
        }
      
      });

    });

}

afg_helpers.modals = (selector,timeBefore = false,timeActive = false) => {

  let modals = document.querySelectorAll(selector);
  
  if(modals === undefined || modals === null) return;
  
  let overlay = document.createElement('div');
  overlay.classList.add('afg-modal-overlay');

  let close = document.createElement('button');
  let text = document.createTextNode('Fermer la fenêtre');
  close.classList.add('afg-close-modal', 'pause');
  close.appendChild(text);
    
  
  modals.forEach( modal => {
    
    if(modal.classList.contains('full-screen')) {
       document.body.appendChild(modal);
    }

    if(modal.classList.contains('afg-active')) {
        overlay.classList.add('afg-active');
    }

    modal.appendChild(close.cloneNode());

    let newOverlay = overlay.cloneNode();
    let parent = modal.parentNode;
      if( !modal.classList.contains('share') ) {
        newOverlay.id = 'overlay-' + modal.id;
        parent.insertBefore(newOverlay, modal);
      }

      if(timeBefore || timeBefore === '0') {
      setTimeout(function(){
        modal.classList.add('afg-active')
        newOverlay.classList.add('afg-active');
      },parseInt(timeBefore));
    }

    if(timeActive && timeActive !== '0') {
      if(timeBefore && timeBefore !== '0') timeActive = parseInt(timeBefore) + parseInt(timeActive);
      setTimeout(function(){
        modal.classList.remove('afg-active')
        newOverlay.classList.remove('afg-active');
      },parseInt(timeActive));
    }

  });

  let links = document.querySelectorAll('.afg-modal-link');

  links.forEach( link => {
    var active = false;

    link.addEventListener("click", function(e){
      e.preventDefault();
      
      var modalId = link.getAttribute("data-href");
      var modal = document.querySelectorAll(modalId)[0];
      
      if(modal !== undefined && modal !== null) {
        if(active == false) {
          modal.classList.add('afg-active');
          active = true;
        } else {
          modal.classList.remove('afg-active');
          active = false;
        }
      }

    }, false);
  });

}

/**
 * 
 * @param el "HTMLElement"
 * @param viewportOrigin "%" | "100" | "0"
 * @param elOrigin "center" | "top" | "bottom"
 * @param tolerance "px"
 * @returns boolean
 */
afg_helpers.isElementInViewport = (el, viewportOrigin = 100, elOrigin = 'center', tolerance = 0) => {
  if(!el) return false;

  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  viewportOrigin = viewportOrigin === 0 ? 0 : windowHeight * (viewportOrigin / 100);

  if(elOrigin === 'center') elOrigin = (rect.top + rect.bottom) / 2;
  if(elOrigin === 'top') elOrigin = rect.top;
  if(elOrigin === 'bottom') elOrigin = rect.bottom;

  if(Math.abs(elOrigin) < (windowHeight - viewportOrigin + tolerance)) return true;
  return false;
}

/**
* ACS Animations
*/
 jQuery(document).ready(function($) {
  
  animateMenu();
  animateSiteIntroduction();
  
  /**
  * Site introduction animation 
  */
  function animateSiteIntroduction() {
    var section = $('#site-intro');
    var elements = [
      $('.intro-title .et_pb_column_3_5',section),
      $('h1',section),
      $('.intro-button .et_pb_column_3_5 .et_pb_button',section),
    ];

    elements.forEach(element => {
      element.addClass('afg-active');
    });

    var logo = $('.intro-logo .et_pb_column_2_5');
    setTimeout(function() { 
      logo.addClass('afg-active');
    },1500);
  }

  /**
  * Main menu animation 
  */
  function animateMenu() { 
    
    $(window).on('DOMContentLoaded load resize scroll', function() { 

      $('.et_pb_section').each(function(){
        var element = $(this)[0];
        if(element !== undefined && element !== null) {
          
          var position = element.getBoundingClientRect();
          
          var vp = $(window).width();

          if(vp > 980) {

              if(position.top <= window.innerHeight - 100 ) {
                setMenuColor($(this));
              }

              if(position.top <= window.innerHeight - 300 ) {
                goForlink($(this));
                

              }

            
          } else {

              if(position.top <= 100 ) {
                setMenuColor($(this));
                goForlink($(this));

                if($(this).prop('id')=='realisations') {
                  var that = $(this);
                  setTimeout(function(){
                   that.addClass('hide-swipe');
                  },4000);
                } 
              }

          }

        }

      });

    });

  }

  /**
  * Main menu animation > Active item
  */
  function goForlink(el) {
    var id = el.attr('id');
    var link = $('header a[href="#'+id+'"]');

    if(id !== undefined && link !== undefined) {
      $('header a:not([href="#'+id+'"])').parent().removeClass('afg-active');
      link.parent().addClass('afg-active');
    }
  }

  /**
  * Main menu animation > Menu color 
  */
  function setMenuColor(el) {
    
    if(el.hasClass('light')) { 
      $('header').addClass('light').removeClass('dark'); 
    } else {
      $('header').addClass('dark').removeClass('light');
    }

    if(el.hasClass('mobile-dark') && $(window).width() <= 980) { 
      $('header').addClass('dark').removeClass('light');
    }

    if( !el.hasClass('dark') && !el.hasClass('light') ) computeColorFromRenderedColor(el[0]);

  }

  /**
  * Main menu animation > Menu color > Compute color from rendered background
  */
  function computeColorFromRenderedColor(el) {
      
    var color = window.getComputedStyle( el ,null).getPropertyValue('background-color');  
    
    if(color !== undefined && color !== null) {
      var matches = null;
      var value = null;
      
      if(matches = color.match(/rgb\((\d+), (\d+), (\d+)\)/) ){
        value = parseInt(matches[1]) + parseInt(matches[2]) + parseInt(matches[3]);
      }

      if(matches = color.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i) ){
        value = parseInt(matches[1],16) + parseInt(matches[2],16) + parseInt(matches[3],16);
      }

      if(value !== null) {
        if(value / 3 >= 158) {
          $('header').addClass('dark').removeClass('light');
        } else {
          $('header').addClass('light').removeClass('dark');
        }
      }

    }
  }

});

afg_helpers.addHeaderOnMobileMenu = () => {
  
  jQuery(document).ready(function($){
    
    var langMenu = $('.afg-lang-selector').clone();
    var mobileMenuHeader = $('<div class="afg-menu-header"></div>').html('<button class="afg-close-modal"></button>');
    
    mobileMenuHeader.prepend(langMenu);
    
    setTimeout(function(){
      var mobileMenu = $('header .mobile_nav ul');
      $('header .mobile_nav ul').prepend(mobileMenuHeader);
    },500);

    $(document).on('click','.afg-close-modal, .afg-toggle-menu',function(){
      $('header .mobile_menu_bar').click();
    });

  });

}

afg_helpers.setPalettes = () => {
  
  jQuery(document).ready(function($){
      
      if(typeof acf == "undefined") return;

      acf.add_filter('color_picker_args', function( args, field ){
              
          args.palettes = afgAjax.ajax_palettes;
              
          return args;

      });

  });
}

afg_helpers.simpleSlider = () => {


  let afgSwiper = new Swiper('.afg-simple-slider', {
    speed: 400,
    slidesPerView: 3,
    slidesPerGroup:3,
    centeredSlides: false,
    spaceBetween: 2,
    autoplay: false,
    progress:true,
    loop: false,
    speed: 1200,
    grabCursor: true,
    mousewheel: false,
    navigation: {
      nextEl: document.querySelector('.swiper-button-next'),
      prevEl: document.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup:1,
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup:2,
      },
      980: {
        slidesPerView: 3,
        slidesPerGroup:3,
      }
    },
  });
  
}

afg_helpers.setScrollToAnchor = () => {
  
  jQuery(function($) {
        
    window.et_pb_smooth_scroll = function( $target, $top_section, speed, easing ) {
      
      /*const regex = new RegExp('acds-projects\.com/[^#][a-z0-9/\.]');
      console.log(document.referrer);
      if(regex.test(document.referrer)) {
        location.href = "#realisations";//+ $target.attr('id');
        return;
      }*/

      var $menu_offset = -1;

      if ( $ ('#wpadminbar').length && $(window).width() > 600 ) {
          $menu_offset += $( '#wpadminbar' ).outerHeight();
      }

      var $scroll_position = 0;

      if ( $top_section ) {
          $scroll_position = 0;
      } else {
          $scroll_position = $target.offset().top - $menu_offset;
      }

      if( typeof easing === 'undefined' ) easing = 'swing';

      $( 'html, body' ).animate( { scrollTop :  $scroll_position }, speed, easing );

    }

  });

}

export default afg_helpers;